import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

import Badge from './assets/Unisport_FC_Badge.png';

// eslint-disable-next-line import/no-cycle
import { MembershipContext } from './Membership';

export default function MembershipHeading({
  as: Component = 'h2',
  className = '',
  children,
  ...restProps
}) {
  const { withBackground } = useContext(MembershipContext);

  return (
    <div className="flex items-center justify-between gap-4">
      <img
        src={Badge}
        width={56}
        height={56}
        alt=""
        className={mergeClasses({
          'order-2': withBackground
        })}
      />
      <Component
        className={mergeClasses(
          'mb-0 mt-0 text-[32px] font-black uppercase leading-none text-black',
          {
            'order-1 text-white': withBackground
          },
          className
        )}
        {...restProps}
      >
        {children}
      </Component>
    </div>
  );
}

MembershipHeading.propTypes = {
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
  className: PropTypes.string,
  children: PropTypes.string.isRequired
};

MembershipHeading.defaultProps = {
  as: 'h2',
  className: ''
};
